import React, { useEffect, useState, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import { useDispatch, useSelector } from 'react-redux'
import { closeDialogRecibo } from '../../store/dialogRecibo/dialogReciboReducer';

import BillByClient from '../../components/bill/BillByClient';
import { ScrollView } from 'devextreme-react';

const Nuevo = (props) => {

    const { dialogRecibo } = useSelector(store => store);

    const dispatch = useDispatch(); 

    const closeDialog = ( load ) => {       

        dispatch(closeDialogRecibo());
        if (load) {
            let { onSave } = props;
            onSave();      
        }        
    }

    const onHiding = ({ load }) => {       
        closeDialog(load);        
    } 

    return (
        <div>
            <Popup
                width={1050}
                height={580}
                title={`Recibos`}
                onHiding={onHiding}
                visible={dialogRecibo.open}
                className="bg-fbfbfb"             
            >
                <ScrollView showScrollbar="onScroll">
                    <BillByClient open={dialogRecibo.open} id={dialogRecibo.id}/>                                       
                </ScrollView>
                
            </Popup>
        </div>
    );
}

export default Nuevo;
